import { defineMessages } from 'react-intl';

const translations = {
  storageUploadDialog: {
    title: {
      id: 'storageUploadDialog.title',
      defaultMessage: 'Upload to storage',
      description: 'Title of the storage upload dialog',
    },
    fields: {
      externalStorages: {
        id: 'properties.externalStorages',
        defaultMessage: 'External storage',
        description: 'Label of the upload external storage field of the storage upload dialog',
      },
      path: {
        id: 'properties.path',
        defaultMessage: 'Path',
        description: 'Label of the path field of the storage upload dialog',
      },
    },
    actions: {
      cancel: {
        id: 'actions.cancel',
        defaultMessage: 'Cancel',
        description: 'Label of the cancel button of the storage upload dialog',
      },
      upload: {
        id: 'actions.upload',
        defaultMessage: 'Upload',
        description: 'Label of the sync button of the storage upload dialog',
      },
    },
  },
};

export default defineMessages(translations);
